import React from 'react';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function MaintenancePage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div role="alert" aria-label="maintenance" data-testid="page-maintenance" style={{ padding: 48, textAlign: 'center' }}>
      <h1 style={{ fontSize: 'var(--font-size-3xl)', color: 'var(--color-warning)' }}>
        {t('errors.maintenance.title')}
      </h1>
      <p>{t('errors.maintenance.detail')}</p>
      <p style={{ color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
        {t('errors.maintenance.body')}
      </p>
    </div>
  );
}
